import React from 'react';
import { SubmitButton } from 'Components/Fields/Buttons';
import { getDefaultConfig } from 'Utils/Store';
import './MobileWatchNowButton.css';
import { setLocation } from 'Utils/Path';

export const WatchNowButton = ({ buttonText = 'Watch Now', isMobile }) => {
  const { rootDomain } = getDefaultConfig();

  if (isMobile) {
    return (
      <button
        type="button"
        className="mobileContinueWatching"
        onClick={() => {
          setLocation(rootDomain);
        }}
      >
        {buttonText}
      </button>
    );
  }
  return (
    <SubmitButton
      className="continueWatching"
      text={buttonText}
      onClick={() => {
        setLocation(rootDomain);
      }}
    />
  );
};
